import React from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  payload: string;
  setPayload: (value: string) => void;
  formatPayload: () => void;
  payloadIsValid: boolean;
  payloadVariablesCount: number;
  payloadArraysCount: number;
};

export default function PayloadInputModal({
  open,
  onClose,
  payload,
  setPayload,
  formatPayload,
  payloadIsValid,
  payloadVariablesCount,
  payloadArraysCount,
}: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 p-5 backdrop-blur-sm">
      <div className="max-h-[92vh] w-full max-w-5xl overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-2xl dark:border-white/10 dark:bg-slate-950">
        <div className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4 dark:border-white/10 dark:bg-slate-950">
          <div>
            <div className="text-xl font-black text-slate-950 dark:text-white">
              Klantpayload invoeren
            </div>
            <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Plak hier de payload die via de HTTP trigger binnenkomt.
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-white/10"
          >
            Sluiten
          </button>
        </div>

        <div className="grid max-h-[calc(92vh-73px)] overflow-hidden lg:grid-cols-[minmax(0,1fr)_280px]">
          <main className="overflow-auto bg-white p-6 dark:bg-slate-950">
            <div className="mb-4 rounded-2xl border border-blue-200 bg-blue-50 p-4 dark:border-blue-500/20 dark:bg-blue-500/10">
              <div className="text-sm font-black text-slate-950 dark:text-white">
                Incoming payload
              </div>
              <div className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
                Deze payload wordt gebruikt om velden te herkennen die je later kunt koppelen aan
                de JDX booking payload.
              </div>
            </div>

            <textarea
              value={payload}
              onChange={(event) => setPayload(event.target.value)}
              placeholder="Plak hier de JSON payload van de klant..."
              className="h-[560px] w-full rounded-2xl border border-slate-200 bg-white p-5 font-mono text-xs leading-6 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-orange-400 dark:border-white/10 dark:bg-slate-950 dark:text-blue-100 dark:placeholder:text-slate-600"
            />
          </main>

          <aside className="space-y-4 overflow-auto border-t border-slate-200 bg-slate-50 p-5 lg:border-l lg:border-t-0 dark:border-white/10 dark:bg-slate-900/50">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-slate-950">
              <div className="text-xs font-black uppercase tracking-wide text-slate-400">
                Status
              </div>

              <div
                className={`mt-3 rounded-xl px-4 py-3 text-sm font-black ${
                  payloadIsValid
                    ? "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"
                    : "bg-red-500/10 text-red-700 dark:text-red-300"
                }`}
              >
                {payloadIsValid ? "Geldige JSON" : "Ongeldige JSON"}
              </div>

              <div className="mt-4 grid grid-cols-2 gap-2">
                <div className="rounded-xl bg-slate-50 p-3 dark:bg-white/5">
                  <div className="text-[10px] font-black uppercase text-slate-400">
                    Velden
                  </div>
                  <div className="mt-1 text-xl font-black text-slate-950 dark:text-white">
                    {payloadVariablesCount}
                  </div>
                </div>

                <div className="rounded-xl bg-slate-50 p-3 dark:bg-white/5">
                  <div className="text-[10px] font-black uppercase text-slate-400">
                    Lijsten
                  </div>
                  <div className="mt-1 text-xl font-black text-slate-950 dark:text-white">
                    {payloadArraysCount}
                  </div>
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={formatPayload}
              className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10"
            >
              JSON netjes maken
            </button>

            <button
              type="button"
              onClick={onClose}
              className="w-full rounded-xl bg-orange-500 px-4 py-3 text-sm font-black text-white transition hover:bg-orange-400"
            >
              Payload opslaan
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
}